import { render, staticRenderFns } from "./SeniorCreate.vue?vue&type=template&id=2489112a&scoped=true&"
import script from "./SeniorCreate.vue?vue&type=script&lang=js&"
export * from "./SeniorCreate.vue?vue&type=script&lang=js&"
import style0 from "./SeniorCreate.vue?vue&type=style&index=0&id=2489112a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489112a",
  null
  
)

export default component.exports